import { Injectable } from '@angular/core';
import { isDevMode } from '@angular/core';

/**
 * Servicio de logging para el frontend de OPB
 * Proporciona métodos de logging consistentes con el backend
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly isDevelopment = isDevMode();
  private readonly isProduction = !isDevMode();

  /**
   * Log de información
   */
  info(message: string, context?: string): void {
    this.log('INFO', message, context);
  }

  /**
   * Log de advertencia
   */
  warn(message: string, context?: string): void {
    this.log('WARN', message, context);
  }

  /**
   * Log de error
   */
  error(message: string, error?: Error, context?: string): void {
    this.log('ERROR', message, context, error);
  }

  /**
   * Log de debug (solo en desarrollo)
   */
  debug(message: string, context?: string): void {
    if (this.isDevelopment) {
      this.log('DEBUG', message, context);
    }
  }

  /**
   * Método privado para formatear y mostrar logs
   */
  private log(level: string, message: string, context?: string, error?: Error): void {
    const timestamp = new Date().toISOString();
    const contextStr = context ? `[${context}]` : '';
    const errorStr = error ? `\n${error.stack}` : '';
    
    const logMessage = `${timestamp} [${level}]${contextStr} ${message}${errorStr}`;
    
    // Usar console según el nivel
    switch (level) {
      case 'ERROR':
        // eslint-disable-next-line no-console
        console.error(logMessage);
        break;
      case 'WARN':
        // eslint-disable-next-line no-console
        console.warn(logMessage);
        break;
      case 'DEBUG':
        // eslint-disable-next-line no-console
        console.debug(logMessage);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log(logMessage);
    }
  }
} 